<div class="relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center">
  <i class="fa-light {{this.icon}} text-3xl text-gray-400"></i>
  <span class="mt-2 block text-sm text-gray-400">{{this.heading}}</span>
</div>